{
  "familyId": "GET-VERGELIJK-JUDGE",
  "questions": [
    {
      "id": "GET-VERGELIJK-JUDGE-001",
      "familyId": "GET-VERGELIJK-JUDGE",
      "module": "Getalbegrip",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "kommagetallen",
      "subSkill": "vergelijk_komma_judge",
      "questionType": "comparison_judge",
      "question": "Welk getal is het grootst?",
      "context": null,
      "data": {
        "comparisonJudge": {
          "items": [
            { "id": "a", "content": "0,7", "label": "nul komma zeven" },
            { "id": "b", "content": "0,65", "label": "nul komma vijfenzestig" },
            { "id": "c", "content": "0,8", "label": "nul komma acht" }
          ],
          "criterion": "het grootst",
          "correctIndex": 2
        }
      },
      "options": [],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Kommagetallen vergelijken",
            "content": "Maak de getallen even lang: 0,70 — 0,65 — 0,80. Vergelijk nu: 80 > 70 > 65. Dus 0,8 is het grootst.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "vergelijk_komma_basis",
      "variantIndex": 1,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "Maak alle getallen even lang achter de komma: 0,70 — 0,65 — 0,80. Nu vergelijk je: 80 honderdsten > 70 honderdsten > 65 honderdsten. Dus 0,8 is het grootst.",
        "solutionSteps": [
          "Maak even lang: 0,70 — 0,65 — 0,80",
          "Vergelijk: 80 > 70 > 65",
          "0,8 is het grootst"
        ]
      },
      "pedagogy": { "dok": 1 }
    },
    {
      "id": "GET-VERGELIJK-JUDGE-002",
      "familyId": "GET-VERGELIJK-JUDGE",
      "module": "Getalbegrip",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "kommagetallen",
      "subSkill": "vergelijk_komma_judge",
      "questionType": "comparison_judge",
      "question": "Welk getal is het kleinst?",
      "context": null,
      "data": {
        "comparisonJudge": {
          "items": [
            { "id": "a", "content": "1,25" },
            { "id": "b", "content": "1,3" },
            { "id": "c", "content": "1,09" }
          ],
          "criterion": "het kleinst",
          "correctIndex": 2
        }
      },
      "options": [],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Kommagetallen vergelijken",
            "content": "Maak even lang: 1,25 — 1,30 — 1,09. Vergelijk: 09 < 25 < 30. Dus 1,09 is het kleinst.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "vergelijk_komma_kleinst",
      "variantIndex": 2,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Maak even lang achter de komma: 1,25 — 1,30 — 1,09. Vergelijk de honderdsten: 09 < 25 < 30. Dus 1,09 is het kleinst.",
        "solutionSteps": [
          "Maak even lang: 1,25 — 1,30 — 1,09",
          "Vergelijk: 09 < 25 < 30",
          "1,09 is het kleinst"
        ]
      },
      "pedagogy": { "dok": 1 }
    },
    {
      "id": "GET-VERGELIJK-JUDGE-003",
      "familyId": "GET-VERGELIJK-JUDGE",
      "module": "Getalbegrip",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "kommagetallen",
      "subSkill": "vergelijk_komma_judge",
      "questionType": "comparison_judge",
      "question": "Welk getal is het grootst?",
      "context": null,
      "data": {
        "comparisonJudge": {
          "items": [
            { "id": "a", "content": "2,4" },
            { "id": "b", "content": "2,38" },
            { "id": "c", "content": "2,5" },
            { "id": "d", "content": "2,45" }
          ],
          "criterion": "het grootst",
          "correctIndex": 2
        }
      },
      "options": [],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Kommagetallen vergelijken",
            "content": "Maak even lang: 2,40 — 2,38 — 2,50 — 2,45. Vergelijk de honderdsten: 50 > 45 > 40 > 38. Dus 2,5 is het grootst.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "vergelijk_komma_basis",
      "variantIndex": 3,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "Maak alle getallen even lang achter de komma: 2,40 — 2,38 — 2,50 — 2,45. Vergelijk de honderdsten: 50 > 45 > 40 > 38. Dus 2,5 is het grootst.",
        "solutionSteps": [
          "Maak even lang: 2,40 — 2,38 — 2,50 — 2,45",
          "Vergelijk de honderdsten: 50 > 45 > 40 > 38",
          "2,5 is het grootst"
        ]
      },
      "pedagogy": { "dok": 1 }
    },
    {
      "id": "GET-VERGELIJK-JUDGE-004",
      "familyId": "GET-VERGELIJK-JUDGE",
      "module": "Getalbegrip",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "kommagetallen",
      "subSkill": "vergelijk_komma_judge",
      "questionType": "comparison_judge",
      "question": "Welk getal ligt het dichtst bij 0,5?",
      "context": null,
      "data": {
        "comparisonJudge": {
          "items": [
            { "id": "a", "content": "0,42" },
            { "id": "b", "content": "0,58" },
            { "id": "c", "content": "0,49" },
            { "id": "d", "content": "0,6" }
          ],
          "criterion": "het dichtst bij 0,5",
          "correctIndex": 2
        }
      },
      "options": [],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "numberline",
          "showWhen": "wrong",
          "data": {
            "start": 0.4,
            "end": 0.65,
            "marked": [0.42, 0.49, 0.58, 0.6],
            "step": 0.05,
            "label": "Getallen rond 0,5 op de getallenlijn"
          }
        },
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Afstand tot 0,5",
            "content": "Reken het verschil met 0,5 uit: |0,42 − 0,5| = 0,08 — |0,58 − 0,5| = 0,08 — |0,49 − 0,5| = 0,01 — |0,6 − 0,5| = 0,1. Het kleinste verschil is 0,01 → 0,49 ligt het dichtst bij 0,5.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "vergelijk_afstand_tot_half",
      "variantIndex": 1,
      "citoDifficulty": 0.50,
      "citoDiscrimination": 0.70,
      "feedback": {
        "explanationText": "Reken de afstand tot 0,5 uit: 0,42 → 0,08 — 0,58 → 0,08 — 0,49 → 0,01 — 0,6 → 0,10. Het kleinste verschil is 0,01, dus 0,49 ligt het dichtst bij 0,5.",
        "solutionSteps": [
          "|0,42 − 0,5| = 0,08",
          "|0,58 − 0,5| = 0,08",
          "|0,49 − 0,5| = 0,01",
          "|0,6 − 0,5| = 0,10",
          "Kleinste verschil: 0,01 → 0,49"
        ]
      },
      "pedagogy": { "dok": 2 }
    },
    {
      "id": "GET-VERGELIJK-JUDGE-005",
      "familyId": "GET-VERGELIJK-JUDGE",
      "module": "Getalbegrip",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "kommagetallen",
      "subSkill": "vergelijk_komma_judge",
      "questionType": "comparison_judge",
      "question": "Welk getal ligt het dichtst bij 1?",
      "context": null,
      "data": {
        "comparisonJudge": {
          "items": [
            { "id": "a", "content": "0,89" },
            { "id": "b", "content": "1,12" },
            { "id": "c", "content": "0,95" },
            { "id": "d", "content": "1,08" }
          ],
          "criterion": "het dichtst bij 1",
          "correctIndex": 2
        }
      },
      "options": [],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "numberline",
          "showWhen": "wrong",
          "data": {
            "start": 0.8,
            "end": 1.2,
            "marked": [0.89, 0.95, 1.08, 1.12],
            "step": 0.1,
            "label": "Getallen op de getallenlijn rond 1"
          }
        },
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Afstand tot 1 berekenen",
            "content": "Bereken het verschil met 1: |0,89 − 1| = 0,11 — |1,12 − 1| = 0,12 — |0,95 − 1| = 0,05 — |1,08 − 1| = 0,08. Het kleinste verschil is 0,05 → 0,95 ligt het dichtst bij 1.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "vergelijk_afstand_tot_1",
      "variantIndex": 1,
      "citoDifficulty": 0.55,
      "citoDiscrimination": 0.66,
      "feedback": {
        "explanationText": "Bereken de afstand tot 1: 0,89 → verschil 0,11 — 1,12 → verschil 0,12 — 0,95 → verschil 0,05 — 1,08 → verschil 0,08. Het kleinste verschil is 0,05, dus 0,95 ligt het dichtst bij 1.",
        "solutionSteps": [
          "|0,89 − 1| = 0,11",
          "|1,12 − 1| = 0,12",
          "|0,95 − 1| = 0,05",
          "|1,08 − 1| = 0,08",
          "Kleinste verschil: 0,05 → 0,95"
        ]
      },
      "pedagogy": { "dok": 2 }
    },
    {
      "id": "GET-VERGELIJK-JUDGE-006",
      "familyId": "GET-VERGELIJK-JUDGE",
      "module": "Getalbegrip",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "kommagetallen",
      "subSkill": "vergelijk_komma_judge",
      "questionType": "comparison_judge",
      "question": "Welk getal is het grootst?",
      "context": null,
      "data": {
        "comparisonJudge": {
          "items": [
            { "id": "a", "content": "2,4" },
            { "id": "b", "content": "2,38" },
            { "id": "c", "content": "2,5" },
            { "id": "d", "content": "2,45" }
          ],
          "criterion": "het grootst",
          "correctIndex": 2
        }
      },
      "options": [],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Kommagetallen vergelijken",
            "content": "Maak even lang: 2,40 — 2,38 — 2,50 — 2,45. Vergelijk de honderdsten: 50 > 45 > 40 > 38. Dus 2,5 is het grootst.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "vergelijk_komma_basis",
      "variantIndex": 3,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "Maak alle getallen even lang achter de komma: 2,40 — 2,38 — 2,50 — 2,45. Vergelijk de honderdsten: 50 > 45 > 40 > 38. Dus 2,5 is het grootst.",
        "solutionSteps": [
          "Maak even lang: 2,40 — 2,38 — 2,50 — 2,45",
          "Vergelijk de honderdsten: 50 > 45 > 40 > 38",
          "2,5 is het grootst"
        ]
      },
      "pedagogy": { "dok": 1 }
    },
    {
      "id": "GET-VERGELIJK-JUDGE-007",
      "familyId": "GET-VERGELIJK-JUDGE",
      "module": "Getalbegrip",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "kommagetallen",
      "subSkill": "vergelijk_komma_judge",
      "questionType": "comparison_judge",
      "question": "Welk getal ligt het dichtst bij 0,5?",
      "context": null,
      "data": {
        "comparisonJudge": {
          "items": [
            { "id": "a", "content": "0,42" },
            { "id": "b", "content": "0,58" },
            { "id": "c", "content": "0,49" },
            { "id": "d", "content": "0,6" }
          ],
          "criterion": "het dichtst bij 0,5",
          "correctIndex": 2
        }
      },
      "options": [],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "numberline",
          "showWhen": "wrong",
          "data": {
            "start": 0.4,
            "end": 0.65,
            "marked": [0.42, 0.49, 0.58, 0.6],
            "step": 0.05,
            "label": "Getallen rond 0,5 op de getallenlijn"
          }
        },
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Afstand tot 0,5",
            "content": "Reken het verschil met 0,5 uit: |0,42 − 0,5| = 0,08 — |0,58 − 0,5| = 0,08 — |0,49 − 0,5| = 0,01 — |0,6 − 0,5| = 0,1. Het kleinste verschil is 0,01 → 0,49 ligt het dichtst bij 0,5.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "vergelijk_afstand_tot_half",
      "variantIndex": 1,
      "citoDifficulty": 0.50,
      "citoDiscrimination": 0.70,
      "feedback": {
        "explanationText": "Reken de afstand tot 0,5 uit: 0,42 → 0,08 — 0,58 → 0,08 — 0,49 → 0,01 — 0,6 → 0,10. Het kleinste verschil is 0,01, dus 0,49 ligt het dichtst bij 0,5.",
        "solutionSteps": [
          "|0,42 − 0,5| = 0,08",
          "|0,58 − 0,5| = 0,08",
          "|0,49 − 0,5| = 0,01",
          "|0,6 − 0,5| = 0,10",
          "Kleinste verschil: 0,01 → 0,49"
        ]
      },
      "pedagogy": { "dok": 2 }
    },
    {
      "id": "GET-VERGELIJK-JUDGE-008",
      "familyId": "GET-VERGELIJK-JUDGE",
      "module": "Getalbegrip",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "kommagetallen",
      "subSkill": "vergelijk_komma_judge",
      "questionType": "comparison_judge",
      "question": "Welk getal is het grootst?",
      "context": null,
      "data": {
        "comparisonJudge": {
          "items": [
            { "id": "a", "content": "2,4" },
            { "id": "b", "content": "2,38" },
            { "id": "c", "content": "2,5" },
            { "id": "d", "content": "2,45" }
          ],
          "criterion": "het grootst",
          "correctIndex": 2
        }
      },
      "options": [],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Kommagetallen vergelijken",
            "content": "Maak even lang: 2,40 — 2,38 — 2,50 — 2,45. Vergelijk de honderdsten: 50 > 45 > 40 > 38. Dus 2,5 is het grootst.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "vergelijk_komma_basis",
      "variantIndex": 3,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "Maak alle getallen even lang achter de komma: 2,40 — 2,38 — 2,50 — 2,45. Vergelijk de honderdsten: 50 > 45 > 40 > 38. Dus 2,5 is het grootst.",
        "solutionSteps": [
          "Maak even lang: 2,40 — 2,38 — 2,50 — 2,45",
          "Vergelijk de honderdsten: 50 > 45 > 40 > 38",
          "2,5 is het grootst"
        ]
      },
      "pedagogy": { "dok": 1 }
    }
  ]
}